const IS_DFA = "Is DFA";
const IS_NFA = "Is NFA";
const NFA_TO_DFA = "NFA to DFA";
const MINIMIZE_DFA = "Minimize DFA";
const TEST_A_STRING = "Test a string";
const HIGHLIGHT_NULL_TRANSITIONS = "Highlight null transitions";

export {
  IS_DFA,
  IS_NFA,
  NFA_TO_DFA,
  MINIMIZE_DFA,
  TEST_A_STRING,
  HIGHLIGHT_NULL_TRANSITIONS,
};
